import { graphql } from "react-relay"
import { QuestionnaireCriticalitySummaryFragment$data } from "@/modules/patients/services/__generated__/QuestionnaireCriticalitySummaryFragment.graphql"

export const QuestionnaireCriticalitySummaryFragment = graphql`
  fragment QuestionnaireCriticalitySummaryFragment on QuestionnaireCriticalitySummaryOutput {
    useCaseName
    criticals
    warnings
    infos
    questionnaireType
  }
`

export type QuestionnaireCriticalitySummaryData = QuestionnaireCriticalitySummaryFragment$data
